import { useQuery } from '@tanstack/react-query';
import { fetchWhatsAppTemplate, fetchWhatsAppTemplates } from './request';
import { WHATSAPP_TEMPLATES_QUERY_KEY } from './key';
import type { WhatsAppTemplateListParams } from '@/types/whatsapp-template';

export const useWhatsAppTemplates = (
  params: WhatsAppTemplateListParams = {}
) => {
  return useQuery({
    queryKey: [WHATSAPP_TEMPLATES_QUERY_KEY, params],
    queryFn: () => fetchWhatsAppTemplates(params),
  });
};

export const useWhatsAppTemplate = (id?: number) => {
  return useQuery({
    queryKey: [WHATSAPP_TEMPLATES_QUERY_KEY, id],
    queryFn: () => fetchWhatsAppTemplate(id!),
    enabled: typeof id === 'number' && id > 0,
  });
};
